import { AmendmentsSearchBar, AmendmentsTable } from '../../components';
import { amendmentHistoryBreadcrumbs } from '../../config/breadcrumbs';
import { useAmendmentHistory } from '../../hooks';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { useMemo } from 'react';

const AmendmentHistory = () => {
  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => amendmentHistoryBreadcrumbs(navigate),
    [navigate]
  );

  const {
    amendments,
    isLoading,
    totalItems,
    totalPages,
    currentPage,
    pageSize,
    filter,
    setFilter,
    handlePageChange,
    handlePageSizeChange,
  } = useAmendmentHistory();

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks actualPage='Historial de enmiendas' breadcrumbs={breadcrumbs} />

      <AmendmentsSearchBar filter={filter} onSearch={setFilter} />

      <AmendmentsTable
        amendments={amendments}
        isLoading={isLoading}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </section>
  );
};

export default AmendmentHistory;
